'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  margin: 0px 15px;\n  cursor: pointer;\n  user-select: none;\n'], ['\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  margin: 0px 15px;\n  cursor: pointer;\n  user-select: none;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  width: calc(100% + 30px);\n  height: 2px;\n  margin: 15px 0px;\n  position: relative;\n'], ['\n  width: calc(100% + 30px);\n  height: 2px;\n  margin: 15px 0px;\n  position: relative;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  line-height: 26px;\n  padding: 0px 10px;\n  background: ', ';\n  border-style: solid;\n  border-width: 2px;\n  border-color: ', ';\n  color: ', ';\n  border-radius: 3px;\n  white-space: nowrap;\n'], ['\n  line-height: 26px;\n  padding: 0px 10px;\n  background: ', ';\n  border-style: solid;\n  border-width: 2px;\n  border-color: ', ';\n  color: ', ';\n  border-radius: 3px;\n  white-space: nowrap;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  border-radius: 50%;\n  border: 2px solid ', ';\n  background: ', ';\n  width: 16px;\n  height: 16px;\n'], ['\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  border-radius: 50%;\n  border: 2px solid ', ';\n  background: ', ';\n  width: 16px;\n  height: 16px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Colors


var boxBackground = function boxBackground(_ref) {
  var selected = _ref.selected,
      highlight = _ref.highlight,
      outline = _ref.outline;
  if (outline) return _colors.white;
  if (selected) return _colors.red;
  if (highlight) return _colors.darkGrey;
  return _colors.grey;
};

var boxBorder = function boxBorder(_ref2) {
  var highlight = _ref2.highlight,
      outline = _ref2.outline,
      selected = _ref2.selected;
  if (outline) return highlight ? _colors.darkGrey : _colors.grey;
  if (selected) return 'transparent';
  if (highlight) return _colors.darkGrey;
  return 'transparent';
};

var boxColor = function boxColor(_ref3) {
  var outline = _ref3.outline,
      selected = _ref3.selected,
      highlight = _ref3.highlight;
  if (outline) return _colors.black;
  if (selected || highlight) return _colors.white;
  return _colors.black;
};

var circleBorder = function circleBorder(_ref4) {
  var selected = _ref4.selected,
      highlight = _ref4.highlight;
  if (selected) return _colors.red;
  if (highlight) return _colors.darkGrey;
  return _colors.grey;
}; // Components


var Container = _styledComponents2.default.div(_templateObject);

var Line = _styledComponents2.default.div(_templateObject2);

var Box = _styledComponents2.default.div(_templateObject3, boxBackground, boxBorder, boxColor);

var Circle = _styledComponents2.default.div(_templateObject4, circleBorder, _colors.white);

var Entry = function Entry(_ref5) {
  var label = _ref5.label,
      value = _ref5.value,
      onClick = _ref5.onClick,
      selected = _ref5.selected,
      highlight = _ref5.highlight;
  return _react2.default.createElement(Container, {
    onClick: onClick
  }, _react2.default.createElement(Box, {
    selected: selected,
    highlight: highlight
  }, label), _react2.default.createElement(Line, null, _react2.default.createElement(Circle, {
    selected: selected,
    highlight: highlight
  })), _react2.default.createElement(Box, {
    selected: selected,
    highlight: highlight,
    outline: true
  }, value));
};

Entry.propTypes = {
  label: _propTypes2.default.node,
  value: _propTypes2.default.node,
  onClick: _propTypes2.default.func,
  selected: _propTypes2.default.bool,
  highlight: _propTypes2.default.bool
};
exports.default = Entry;